import {
    Box,
    Button,
    Grid,
    Hidden,
    List,
    ListItem,
    ListItemAvatar,
    ListItemText,
    Typography,
    useTheme,
} from "@material-ui/core";
import clsx from "clsx";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import meetingRoom from "../../assets/images/meeting.svg";
import privateLounge from "../../assets/images/private.svg";
import publicHall from "../../assets/images/public.svg";
import pic from "../../assets/images/setupmeeting.png";
import vipCircle from "../../assets/images/vip.svg";
import { useStyles } from "../../components/common/MainStyles.jsx";
import { IsNullOrEmpty } from "../../helpers/utility";
import {
    clearShoppingRequest,
    getCategoryRequest,
} from "../../store/shopping/shopping.actions";
import { getCategoryList } from "../../store/shopping/shopping.selector";
import { getDeliveryAddressRequest } from "../../store/user/deliveryaddress/deliveryaddress.actions";
import { searchUserRequest } from "../../store/user/user.actions";
import { getVIPCircleRequest } from "../../store/user/vipcircle/vipcircle.actions";
import { getCurrentVIPCircle } from "../../store/user/vipcircle/vipcircle.selector";
import CreateVipCircle from "./create_vip_circle";
import SelectVIPCircle from "./select_vip_circle";
import CreateMeetingRoom from "./setup_meeting_room";
import SetUpPrivateHall from "./setup_private_hall";
import SetupPublicHall from "./setup_public_hall";

export default function SetupMeeting(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const classes = useStyles();
    const history = useNavigate();
    const theme = useTheme();
    const [step, setStep] = useState(1);
    const [selectedCategory, setSelectedCategory] = useState({});

    const { categories, vipCircles } = useSelector((state) => {
        return {
            categories: getCategoryList(state),
            vipCircles: getCurrentVIPCircle(state),
        };
    });

    useEffect(() => {
        if (location && location.state && location.state.category) {
            let name = categories.filter((x) => {
                return x._id === location.state.category;
            });

            if (name.length > 0) {
                setStep(2);
                setSelectedCategory(name[0]);
            }
        }
    }, [location]);

    useEffect(() => {
        dispatch(getDeliveryAddressRequest());
        dispatch(clearShoppingRequest());
        dispatch(getCategoryRequest());
        dispatch(getVIPCircleRequest());
        dispatch(searchUserRequest());
    }, []);

    if (step === 2) {
        if (selectedCategory.name === "VIP Circle") {
            if (vipCircles.length === 0) {
                return (
                    <CreateVipCircle
                        category={selectedCategory}
                        onClose={() => {
                            setStep(1);
                            setSelectedCategory({});
                        }}
                    />
                );
            } else {
                return (
                    <SelectVIPCircle
                        category={selectedCategory}
                        onClose={() => {
                            setStep(1);
                            setSelectedCategory({});
                        }}
                    />
                );
            }
        } else if (selectedCategory.name === "Meeting Room") {
            return (
                <CreateMeetingRoom
                    category={selectedCategory}
                    onClose={() => {
                        setStep(1);
                        setSelectedCategory({});
                    }}
                />
            );
        } else if (selectedCategory.name === "Private Hall") {
            return (
                <SetUpPrivateHall
                    category={selectedCategory}
                    onClose={() => {
                        setStep(1);
                        setSelectedCategory({});
                    }}
                />
            );
        } else {
            return (
                <SetupPublicHall
                    category={selectedCategory}
                    onClose={() => {
                        setStep(1);
                        setSelectedCategory({});
                    }}
                />
            );
        }
    }

    return (
        <main className={classes.main}>
            <Grid container className="h-[100%]">
                <Grid item xs={12} sm={12} lg={8} md={8} className="px-4">
                    <Grid container className="pb-4">
                        <Grid item xs={12} sm={12} className="mb-2">
                            <Typography
                                variant="h5"
                                component="p"
                                className={classes.title}
                            >
                                Choose space
                            </Typography>
                            <Typography
                                variant="p"
                                component="p"
                                className={classes.subTitle}
                            >
                                Select the space you need for your next live
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid item sm={12} xs={12} className={classes.endDiv}>
                        <Grid container spacing={3}>
                            {categories
                                .filter((s) => {
                                    return (
                                        s.name !== "Meeting Room" &&
                                        s.name !== "VIP Circle"
                                    );
                                })
                                .map((item) => {
                                    return (
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={6}
                                            lg={6}
                                        >
                                            <List
                                                className={clsx(
                                                    classes.bgwhite,
                                                    classes.borderRadius
                                                )}
                                                style={{
                                                    border:
                                                        item._id ===
                                                        selectedCategory._id
                                                            ? "3px solid " +
                                                              theme.palette
                                                                  .primary.main
                                                            : "1px solid #E1E1E1",
                                                }}
                                                onClick={() =>
                                                    setSelectedCategory(item)
                                                }
                                            >
                                                <ListItem>
                                                    <ListItemAvatar className="mx-4">
                                                        <img
                                                            src={
                                                                item.name ===
                                                                "Public Hall"
                                                                    ? publicHall
                                                                    : item.name ===
                                                                      "Private Hall"
                                                                    ? privateLounge
                                                                    : item.name ===
                                                                      "Meeting Room"
                                                                    ? meetingRoom
                                                                    : vipCircle
                                                            }
                                                        />
                                                    </ListItemAvatar>
                                                    <ListItemText
                                                        primary={
                                                            item.name ===
                                                            "Private Hall"
                                                                ? "Private Lounge"
                                                                : item.name
                                                        }
                                                        secondary={
                                                            item.description
                                                        }
                                                        classes={{
                                                            primary:
                                                                classes.dashboardSubDarkTitle,
                                                            secondary:
                                                                classes.dashboardTitle,
                                                        }}
                                                    />
                                                </ListItem>
                                            </List>
                                        </Grid>
                                    );
                                })}
                        </Grid>

                        <div className="my-4">
                            <Button
                                variant="contained"
                                color={"inherit"}
                                className={classes.bgwhite}
                                onClick={() => history("/")}
                            >
                                Cancel
                            </Button>
                            <Button
                                disabled={IsNullOrEmpty(selectedCategory._id)}
                                variant="contained"
                                color={
                                    IsNullOrEmpty(selectedCategory._id)
                                        ? "inherit"
                                        : "secondary"
                                }
                                onClick={() =>
                                    IsNullOrEmpty(selectedCategory._id)
                                        ? ""
                                        : setStep(2)
                                }
                            >
                                Next
                            </Button>
                        </div>
                    </Grid>
                </Grid>
                <Grid item xs={12} sm={12} lg={4} md={4}>
                    <Hidden implementation="js" only={["xs", "sm"]}>
                        <Box className="side-image-box">
                            <img
                                src={pic}
                                alt="pic"
                                className="img-responsive rounded-xl"
                            />
                        </Box>
                    </Hidden>
                </Grid>
            </Grid>
        </main>
    );
}
